import { useEffect, useState } from 'react';

/** Giá trị chỉ cập nhật sau khi ngừng thay đổi `delayMs` — dùng cho ô tìm kiếm. */
export function useDebounced<T>(value: T, delayMs = 400): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return debounced;
}
